import { environment } from '../../../environments/environment';

const SESSION_PATH: string = `${environment.API_HOST}/sessions`;
const APPLICATIONS_PATH: string = `${environment.API_HOST}/applications`;

export const HttpConstants = {
  API_AUTH: `${environment.API_HOST}/auth`,
  API_INITIATE: SESSION_PATH,
  API_MERCHANT_APPLICATIONS: (sessionId) => `${SESSION_PATH}/${sessionId}/correspondences`,
  API_SIGN: (sessionId: string, contractId: string) => `${SESSION_PATH}/${sessionId}/contracts/${contractId}/sign`,
  API_CONTRACTS: (sessionId: string) => `${SESSION_PATH}/${sessionId}/contracts`,
  API_CONTRACTS_DOWNLOAD: (sessionId: string, applicationId: string, contractId: string) =>
    `${SESSION_PATH}/${sessionId}/applications/${applicationId}/contracts/${contractId}`,
  API_MERCHANT_DOCUMENTS: (sessionId: string) => `${SESSION_PATH}/${sessionId}/documents`,
  API_MERCHANT_DOCUMENTS_SUBMIT: (sessionId: string) => `${SESSION_PATH}/${sessionId}/documents-submitted`,
  API_MERCHANT_DOCUMENTS_DOWNLOAD: (sessionId: string, documentId: number) =>
    `${SESSION_PATH}/${sessionId}/documents/${documentId}/download-form`,
  APPLICATION_FORM_URLENCODED_HEADER: 'application/x-www-form-urlencoded',
  APPLICATION_JSON_HEADER: 'application/json',
  APPLICATION_PDF_HEADER: 'application/pdf',
  TEXT_PLAIN_HEADER: 'text/plain',
  ALL_TYPES_HEADER: '*/*',
  API_IP_DETAILS: `${environment.API_HOST}/ip-details`,
  API_SIMPLE_CAPTCHA: `${environment.API_HOST}/captcha/image?width=300&height=57`,
  API_ONBOARD: (sessionId: string) => `${SESSION_PATH}/${sessionId}/create-application`,
  API_SAVE: (sessionId: string) => `${SESSION_PATH}/${sessionId}/save-application`,
  API_SESSIONS: (sessionId: string): string => `${SESSION_PATH}/${sessionId}/data`,
  API_STATES: (countryId: string) => `${environment.API_HOST}/countries/${countryId}/states`,
  API_COUNTRIES: `${environment.API_HOST}/countries`,
  API_INDUSTRIES: `${environment.API_HOST}/industries`,
  API_CURRENCIES: `${environment.API_HOST}/currencies`,
  API_SHOPPING_CARTS: `${environment.API_HOST}/shopping-carts`,
  API_VALIDATE: `${environment.API_HOST}/merchant/validate`,
  API_SALESFORCE_LEAD: `${environment.API_HOST}/merchant/salesforce/lead/contact`,
  RESPONSE_MESSAGE: {
    SESSION_SUBMITTED: 'SESSION_SUBMITTED',
    EXPIRED_SESSION: 'EXPIRED_SESSION',
    INVALID_SESSION: 'INVALID_SESSION',
    NOT_FOUND: 'Not Found'
  }
};
